import React, { useRef } from 'react';
import Dialog from '../ui/Dialog';

interface SignOutDialogProps {
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Asks before ending the session (item 52). Cancel takes the focus, so Enter never signs out by
 * accident. Cancel is the way out, so the dialog has no corner button.
 */
const SignOutDialog: React.FC<SignOutDialogProps> = ({ onCancel, onConfirm }) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog title="Sign out of Arbitium?" size="sm" closeButton={false} initialFocus={cancelRef} onClose={onCancel}>
      <p className="text-c3-mute text-sm">
        This ends your session on all your devices. You will need to sign in again.
      </p>
      <div className="flex gap-3 mt-5">
        <button type="button" className="c3-btn c3-btn-primary" onClick={onConfirm}>
          Sign out
        </button>
        <button ref={cancelRef} type="button" className="c3-btn c3-btn-ghost" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </Dialog>
  );
};

export default SignOutDialog;
